import styled from 'styled-components';

export const ContainerStyled = styled.div`
    font-size: ${props => `${props.fontSize}px !important`};
    button {
        font-size: ${props => `${props.fontSize}px !important`};
    }
`